import React from 'react';
import { useStorage } from '../../context/StorageContext';
import './StorageDisplay.scss'

export const StorageDisplay = () => {
    const { formattedUsed, formattedTotal, percentage, isLoading } = useStorage();

    if (isLoading) return <div className="storage-display-loading">Calculating storage...</div>;

    const progressColorClass = percentage > 90 ? '#dc3545' : percentage > 75 ? '#ffc107' : '#28a745';

    return (
        <div className="storage-display-container">
            <div className="storage-header">
                <span className="storage-label">Storage Used:</span>
                <span className="storage-stats">{formattedUsed} / {formattedTotal}</span>
            </div>
            <div className="storage-progress-bar">
                <div 
                    className="storage-progress-fill" 
                    style={{ width: `${percentage}%`, backgroundColor: progressColorClass }}
                />
            </div>
        </div>
    );
};